import { render } from "./App.vue?vue&type=template&id=06a7d162"
const script = {}

import "./App.vue?vue&type=style&index=0&id=06a7d162&lang=css"

import exportComponent from "I:\\MyProject\\PHP\\GPT\\upay\\service_html\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__